export default {
  time: 0,
  successionCount: 0,
  status: 'IDLE',
  aggregate: {
    totalWorked: 0,
    totalBreakTaken: 0,
  },
}
